<template>
  <div class="lines-bg">
    <page-header :content="children[0].fields"/>

    <div class="fun-card-details">
      <div>
        <form class="form-default relative" v-on:submit.prevent="checkBalance">
          <input type="text" name="cardNumber" placeholder="FUNcard (16-digits)" v-model="funCard.number" />
          <input type="text" name="cardPin" placeholder="4-Digit Pin" maxlength="4" v-model="funCard.pin" />
          <button class="pulse purple" :disabled="loading">
            Check Balance
          </button>
          <div class="mt-4 font-bold uppercase" v-html="balance" />
          <div v-if="loading" class="absolute inset-0 bg-white-95 flex jusify-center items-center">
            <loader color="purple" />
          </div>
        </form>

        <div class="details-section flex-wrap mb-6">
          <div v-if="children[1].fields.legal" class="details-section-legal pb-3 opacity-0" v-animate-onscroll="'animated fadeIn'">
            <body-copy :content="children[1].fields.legal.content"/>
          </div>
        </div>
      </div>

      <div class="details-section right-column">
        <div class="details-section-details mt-0 w-auto">
          <body-copy :content="children[1].fields.detailsColumnOne.content"/>
        </div>
      </div>
    </div>

    <div class="fun-card-details"> 
      <div class="details-section bottom-column">
        <div class="details-section-details mt-0 w-auto">
          <body-copy :content="children[1].fields.detailsColumnOne.content"/>
          <body-copy :content="children[1].fields.detailsColumnTwo.content"/>
        </div>
      </div>
    </div>
    <!-- <div class="flex flex-wrap justify-center">
      <div class="w-550">
        <form class="form-default relative" v-on:submit.prevent="checkBalance">
          <input type="text" name="cardNumber" placeholder="FUNcard" v-model="funCard.number" />
          <input type="text" name="cardPin" placeholder="4-Digit Pin" maxlength="4" v-model="funCard.pin" />
          <button class="pulse purple" :disabled="loading">
            Check Balance
          </button>
          <div class="mt-4 font-bold uppercase" v-html="balance" />
          <div v-if="loading" class="absolute inset-0 bg-white-95 flex jusify-center items-center">
            <loader color="purple" />
          </div>
        </form>
        <div class="details-section flex-wrap mb-6">
          <div v-if="children[1].fields.legal" class="details-section-legal pb-3 opacity-0" v-animate-onscroll="'animated fadeIn'">
            <body-copy :content="children[1].fields.legal.content"/>
          </div>
        </div>
      </div>
      <div class="details-section">
        <div class="details-section-details mt-0 w-auto">
          <body-copy :content="children[1].fields.detailsColumnOne.content"/>
        </div>
      </div>
    </div>
    <div class="bottom-section">
      <div class="details-section mt-1 w-full">
        <body-copy class="md:hidden" :content="children[1].fields.detailsColumnOne.content"/>
        <body-copy :content="children[1].fields.detailsColumnTwo.content"/>
      </div>
    </div> -->

  </div>
</template>

<script>
import Loader from '~/components/common/Loader'
import PageSections from '~/components/PageSections'
import PageHeader from '~/components/common/PageHeader'
import BodyCopy from '~/components/common/BodyCopy'

export default {
  components: {
    Loader,
    PageSections,
    PageHeader,
    BodyCopy,
  },
  data() {
    return {
      funCard: {
        number: null,
        pin: null
      },
      amount: null,
      cash: 0,
      showCash: false,
      loading: false,
      error: false
    }
  },
  async asyncData({ $api }) {
    return {
      page: await $api.getPage('fun-cards')
    }
  },
  head() {
    return this.$metadata(this.page)
  },
  computed: {
    children() {
      return this.page.fields.children ? this.page.fields.children : []
    },
    balance() {
      if(this.loading == true) {
        return ' '
      } else if(this.error == true) {
        return 'We could not find your card.<br />Check your number and try again.<br /><small class="font-normal leading-none text-xs">(ex. 0123-4567-8910-1112)</small></small>'
      } else if(this.amount != null) {
        return `Your point balance is ${this.amount}${this.showCash ? `<br/>Your cash balance is $${this.cash}` : ``}`
      } else {
        return ' '
      }
    }
  },
  methods: {
    async checkBalance() {
      if(this.funCard.number && this.funCard.number.match(/^(0000|0700)\-?\d{4}\-?\d{4}\-?\d{4}$/) && this.funCard.pin && this.funCard.pin.match(/\d{4}/)) {
        try {
          this.error = false
          this.loading = true
          this.showCash = this.funCard.number.match(/^0700/) ? false : true
          this.amount = await this.$mulesoft.funCardBalance(this.funCard.number.replace(/\-/g, ''), this.funCard.pin)
          .then(res => {
            this.cash = res.data.cashBalance
            return res.data.pointBalance
          }).catch(err => {
            this.error = true
            return null
          })
          this.loading = false
        } catch(err) {
          this.error = true
          this.loading = false
          console.error(err)
        }
      } else {
        this.loading = true
        this.error = false
        setTimeout(() => {
          this.loading = false
          this.error = true
        }, 1000)
      }
    }
  }
}
</script>
